import i18n from '@/i18n/i18n.js';
import store from '@/store/vuex.js';

const getModulo = (descricao) => {
    if (typeof descricao != 'string') {
        console.error('[MODULOPDA] Tipo inválido da descrição.');
        return null;
    }

    if (store.state.modulopda && store.state.modulopda.disponivel) {
        let modulo = store.state.modulopda.data.find(
            (e) => e.descricao.toUpperCase() == descricao.toUpperCase()
        );

        if (modulo) {
            return {
                idmodulopda: modulo.idmodulopda,
                descricao: modulo.descricao,
                altera: !!modulo.altera,
                inclui: !!modulo.inclui,
                detalhe: modulo.detalhe.map((m) => {
                    return {
                        idmodulopdadetalhe: m.idmodulopdadetalhe,
                        campo: m.campo,
                        label: m.label,
                        tipo: m.tipo,
                        valorpadrao: m.valorpadrao,
                        altera: !!m.altera,
                        oculta: !!m.oculta,
                        obrigainclusao: !!m.obrigainclusao,
                        obrigaalteracao: !!m.obrigaalteracao,
                        validchars: m.validchars,
                        maxlength: m.maxlength,
                    };
                }),
            };
        } else {
            console.warn(`[MODULOPDA] Módulo ${descricao} não encontrado.`);
            return null;
        }
    } else {
        console.warn('[MODULOPDA] MODULOPDA indisponível.');
        return null;
    }
};

const hasModulo = (descricao) => {
    if (typeof descricao != 'string') {
        console.error('[MODULOPDA] Tipo inválido da descrição.');
        return null;
    }

    if (store.state.modulopda && store.state.modulopda.disponivel) {
        return store.state.modulopda.data.some(
            (e) => e.descricao.toUpperCase() == descricao.toUpperCase()
        );
    } else {
        console.warn('[MODULOPDA] MODULOPDA indisponível.');
        return false;
    }
};

const debounce = (func, wait = 500, immediate = false) => {
    let timeout;
    // #70804 - Para não carregar os dados quando a página/função for iniciada e sim após digitar na busca pela primeira vez
    let startedData = false;
    return function () {
        if (startedData) {
            let context = this,
                args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && timeout != null;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        } else {
            startedData = true;
        }
    };
};

const orderByLabelCombo = (a, b) => {
    const id = a.label.toUpperCase();
    const label = b.label.toUpperCase();
    let comparison = 0;
    if (id > label) {
        comparison = 1;
    } else if (id < label) {
        comparison = -1;
    }
    return comparison;
};

const validateEmail = (email) => {
    let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

const validateWhatsapp = (whatsapp) => {
    let wpp = new RegExp(
        '^(?:(?:\\+|00)?(55)\\s?)?(?:\\(?([1-9][0-9])\\)?\\s?)?(?:((?:9\\d|[2-9])\\d{3})\\-?(\\d{4}))$'
    ).test(whatsapp);
    return wpp;
};

const validateCPF = (strCPF) => {
    strCPF = strCPF.replace(/[^\d]+/g, '');

    if (strCPF == '') return false;
    if (strCPF.length != 11) return false;
    let Soma = 0;

    // Elimina strCPF invalidos conhecidos
    if (
        strCPF == '00000000000' ||
        strCPF == '11111111111' ||
        strCPF == '22222222222' ||
        strCPF == '33333333333' ||
        strCPF == '44444444444' ||
        strCPF == '55555555555' ||
        strCPF == '66666666666' ||
        strCPF == '77777777777' ||
        strCPF == '88888888888' ||
        strCPF == '99999999999'
    )
        return false;

    for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    let Resto = (Soma * 10) % 11;

    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if (Resto == 10 || Resto == 11) Resto = 0;

    return Resto == parseInt(strCPF.substring(10, 11));
};

const validateCnpj = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj == '') return false;
    if (cnpj.length != 14) return false;

    // Elimina CNPJs invalidos conhecidos
    if (
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999'
    )
        return false;

    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let i;
    let pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    return resultado == digitos.charAt(1);
};

const downloadPpt = (url, name) => {
    let a = window.document.createElement('a');
    a.href = url;
    a.download = name + new Date().getTime() + '.pptx';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        document.body.removeChild(a);
    }, 1000);
};

const isValidDate = (dateString) => {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false;

    // Parse the date parts to integers
    let parts = dateString.split('/');
    let day = parseInt(parts[0], 10);
    let month = parseInt(parts[1], 10);
    let year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month == 0 || month > 12) return false;

    let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
};

const validateHour = (value) => {
    let isValid = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/.test(value);
    return isValid;
};

function validateValuePhoneBR(value) {
    value = value.replaceAll('(', '');
    value = value.replaceAll(')', '');
    value = value.replaceAll('-', '');
    value = value.replaceAll(' ', '');
    value = value.slice(2, 13);
    return value;
}

const validatePhone = (value) => {
    if (validateBR(value)) {
        value = validateValuePhoneBR(value);
        let expressionPhone = new RegExp('^[1-9]{2}[2-8][0-9]{3}[0-9]{4}$');
        let expressionCellphone = new RegExp('^[1-9]{2}9[1-9]{1}[0-9]{3}[0-9]{4}$');

        let regexPhone = new RegExp(expressionPhone);
        let checkPhone = regexPhone.test(value);
        let regexCellPhone = new RegExp(expressionCellphone);
        let checkCellPhone = regexCellPhone.test(value);

        return checkPhone || checkCellPhone;
    } else {
        return value.length >= 8;
    }
};

const validateCellPhone = (value) => {
    if (validateBR(value)) {
        value = validateValue(value);
        let expression = new RegExp('^[1-9]{2}9[1-9]{1}[0-9]{3}[0-9]{4}$');

        let regex = new RegExp(expression);
        return regex.test(value);
    } else {
        return value.length >= 10;
    }
};

/*
    padrão do Web/FV (código do país em vez do número do DDI, separado por espaço: 'CA 3437895151')
*/
const changeDDIPattern = (value, countries) => {
    if (!isNull(value)) {
        let ddiNumerico = value.split(' ')[0].trim();
        let ddi = countries.find((f) => f.iso2 == ddiNumerico).dialCode;
        let numero = value.split(' ')[1].trim();
        if (ddi == undefined) ddi = ddiNumerico;

        return ddi + ' ' + numero;
    }
};

const formatPhoneNumber = (value) => {
    value = value.replace(/\D/g, '');
    value = value.padStart(11, '0');

    // (XX) XXXX-XXXX
    return `(${value.substring(0, 2)}) ${value.substring(2, 6)}-${value.substring(6)}`;
};

const formatCEP = (value) => {
    let cleaned = value.replace(/\D/g, '');

    if (cleaned.length !== 8) {
        console.warn('[UTIL] O CEP deve conter 8 dígitos.');
        return cleaned;
    } else {
        const formatted = cleaned.slice(0, 5) + '-' + cleaned.slice(5, 8);

        return formatted;
    }
};

const formatCNPJ = (value) => {
    let cleaned = value.replace(/\D/g, '');

    if (cleaned.length !== 14) {
        return '';
    } else {
        const formatted = `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(
            5,
            8
        )}/${cleaned.slice(8, 12)}-${cleaned.slice(12, 14)}`;

        return formatted;
    }
};

const formatCPF = (value) => {
    value = value.replace(/\D/g, '');

    value = value.padStart(11, '0');

    return `${value.substring(0, 3)}.${value.substring(3, 6)}.${value.substring(
        6,
        9
    )}-${value.substring(9)}`;
};

const hexToRgb = (hex) => {
    // Remove the hash (#) if it's present
    hex = hex.replace(/^#/, '');

    // Parse the R, G, and B components
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return { r, g, b };
};

const rgbToHsl = (r, g, b) => {
    r /= 255;
    g /= 255;
    b /= 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h,
        s,
        l = (max + min) / 2;

    if (max === min) {
        h = s = 0; // Grayscale
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }

        h /= 6;
    }

    // Convert to hsl values
    h = Math.round(h * 360);
    s = Math.round(s * 100);
    l = Math.round(l * 100);

    return { h, s, l };
};

function validateBR(value) {
    let valueBR = value.slice(0, 2);
    return valueBR == 'BR';
}

function validateValue(value) {
    value = value.replaceAll('(', '');
    value = value.replaceAll(')', '');
    value = value.replaceAll('-', '');
    value = value.replaceAll(' ', '');

    value = value.slice(2, 13);

    return value;
}

const validateCEP = (value) => {
    value = value.replaceAll('.', '');
    value = value.replaceAll('-', '');
    return value.length == 8;
};

const validateIE = (value) => {
    // if (value.length < 8 || value.length > 14){
    return value.length >= 8;
};
const validateRG = (value) => {
    return value.length >= 4;
};

const removeAcentos = (value) => {
    if (typeof value == 'string') {
        const A = /[ÂÃÀÁÄ]/g;
        const E = /[ÊÈÉË]/g;
        const I = /[ÎÌÍÏ]/g;
        const O = /[ÔÕÒÓÖ]/g;
        const U = /[ÛÙÚÜ]/g;
        const Y = /[ÝŸ]/g;
        const N = /Ñ/g;
        const C = /Ç/g;

        return value
            .toUpperCase()
            .replace(A, 'A')
            .replace(E, 'E')
            .replace(I, 'I')
            .replace(O, 'O')
            .replace(U, 'U')
            .replace(Y, 'Y')
            .replace(N, 'N')
            .replace(C, 'C');
        //.trim();
    } else {
        console.warn('[UTIL] Removendo acentos de objeto que não é uma string.');
        return value;
    }
};

// filtrar para pesquisas, nesta função remove as vírgulas que servem como separação em params...
const removeToSearch = (value, manterAcentos = false) => {
    if (typeof value == 'string') {
        if (!manterAcentos) {
            const A = /[ÂÃÀÁÄ]/g;
            const a = /[âãàáä]/g;
            const E = /[ÊÈÉË]/g;
            const e = /[êèéë]/g;
            const I = /[ÎÌÍÏ]/g;
            const i = /[îìíï]/g;
            const O = /[ÔÕÒÓÖ]/g;
            const o = /[ôõòóö]/g;
            const U = /[ÛÙÚÜ]/g;
            const u = /[ûùúü]/g;
            const Y = /[ÝŸ]/g;
            const y = /[ýÿ]/g;
            const N = /Ñ/g;
            const n = /[ñ]/g;
            const C = /Ç/g;
            const c = /[ç]/g;
            value = value
                .replace(A, 'A')
                .replace(a, 'a')
                .replace(E, 'E')
                .replace(e, 'e')
                .replace(I, 'I')
                .replace(i, 'i')
                .replace(O, 'O')
                .replace(o, 'o')
                .replace(U, 'U')
                .replace(u, 'u')
                .replace(Y, 'Y')
                .replace(y, 'y')
                .replace(N, 'N')
                .replace(n, 'n')
                .replace(C, 'C')
                .replace(c, 'c');
        }
        // \u00C0-\u00FF manter acentos
        const special = /[^A-Z0-9 \u00C0-\u00FF\-\?\!\.\@\n]/gi;
        return value.replace(special, '').trim();
    } else {
        console.warn('[UTIL] Removendo caracteres de objeto que não é uma string.');
        return value;
    }
};

const mapTosave = (value, ...exs) => {
    // exs = campos excluidos da verificação
    // Ex: Util.mapTosave(Objformulario, 'uuid', 'data')
    const A = /[ÂÃÀÁÄ]/g;
    const E = /[ÊÈÉË]/g;
    const I = /[ÎÌÍÏ]/g;
    const O = /[ÔÕÒÓÖ]/g;
    const U = /[ÛÙÚÜ]/g;
    const Y = /[ÝŸ]/g;
    const N = /Ñ/g;
    const C = /Ç/g;

    const special = /[^a-zA-Z0-9 \-\?\!\.\,\@\n]/gi;

    if (typeof value == 'string') {
        return value
            .toUpperCase()
            .replace(A, 'A')
            .replace(E, 'E')
            .replace(I, 'I')
            .replace(O, 'O')
            .replace(U, 'U')
            .replace(Y, 'Y')
            .replace(N, 'N')
            .replace(C, 'C')
            .replace(special, ' ')
            .trim();
    } else {
        for (const key in value) {
            if (
                value.hasOwnProperty(key) &&
                exs.indexOf(key) == -1 &&
                !key.includes('datahora') &&
                key != 'datainicio' &&
                key != 'datafim' &&
                key != 'data' &&
                key != 'color' &&
                key != 'cor' &&
                key != 'icon' &&
                key != 'statusinsercao' &&
                key != 'hash' &&
                key != 'login' &&
                key != 'senha' &&
                !key.includes('uuid')
            ) {
                const el = value[key];
                if (typeof el == 'string') {
                    value[key] = el
                        .toUpperCase()
                        .replace(A, 'A')
                        .replace(E, 'E')
                        .replace(I, 'I')
                        .replace(O, 'O')
                        .replace(U, 'U')
                        .replace(Y, 'Y')
                        .replace(N, 'N')
                        .replace(C, 'C')
                        .replace(special, ' ')
                        .trim();
                }
            }
        }
    }
    return value;
};

const mapToSavePreserveCase = (value, ...exs) => {
    const A = /[ÂÃÀÁÄ]/g;
    const a = /[âãàáä]/g;
    const E = /[ÊÈÉË]/g;
    const e = /[êèéë]/g;
    const I = /[ÎÌÍÏ]/g;
    const i = /[îìíï]/g;
    const O = /[ÔÕÒÓÖ]/g;
    const o = /[ôõòóö]/g;
    const U = /[ÛÙÚÜ]/g;
    const u = /[ûùúü]/g;
    const Y = /[ÝŸ]/g;
    const y = /[ýÿ]/g;
    const N = /Ñ/g;
    const n = /[ñ]/g;
    const C = /Ç/g;
    const c = /[ç]/g;

    const special = /[^a-zA-Z0-9 \-\?\!\.\,\@\n]/gi;

    if (typeof value == 'string') {
        return value
            .replace(A, 'A')
            .replace(a, 'a')
            .replace(E, 'E')
            .replace(e, 'e')
            .replace(I, 'I')
            .replace(i, 'i')
            .replace(O, 'O')
            .replace(o, 'o')
            .replace(U, 'U')
            .replace(u, 'u')
            .replace(Y, 'Y')
            .replace(y, 'y')
            .replace(N, 'N')
            .replace(n, 'n')
            .replace(C, 'C')
            .replace(c, 'c')
            .replace(special, ' ')
            .trim();
    } else {
        for (const key in value) {
            if (
                value.hasOwnProperty(key) &&
                exs.indexOf(key) == -1 &&
                !key.includes('datahora') &&
                key != 'datainicio' &&
                key != 'datafim' &&
                key != 'data' &&
                key != 'color' &&
                key != 'cor' &&
                key != 'icon' &&
                key != 'statusinsercao' &&
                key != 'hash' &&
                !key.includes('uuid')
            ) {
                const el = value[key];
                if (typeof el == 'string') {
                    value[key] = el
                        .trim()
                        .replace(A, 'A')
                        .replace(a, 'a')
                        .replace(E, 'E')
                        .replace(e, 'e')
                        .replace(I, 'I')
                        .replace(i, 'i')
                        .replace(O, 'O')
                        .replace(o, 'o')
                        .replace(U, 'U')
                        .replace(u, 'u')
                        .replace(Y, 'Y')
                        .replace(y, 'y')
                        .replace(N, 'N')
                        .replace(n, 'n')
                        .replace(C, 'C')
                        .replace(c, 'c')
                        .replace(special, ' ')
                        .trim();
                }
            }
        }
    }

    return value;
};

const mapToSaveURL = (value, ...exs) => {
    const A = /[ÂÃÀÁÄ]/g;
    const a = /[âãàáä]/g;
    const E = /[ÊÈÉË]/g;
    const e = /[êèéë]/g;
    const I = /[ÎÌÍÏ]/g;
    const i = /[îìíï]/g;
    const O = /[ÔÕÒÓÖ]/g;
    const o = /[ôõòóö]/g;
    const U = /[ÛÙÚÜ]/g;
    const u = /[ûùúü]/g;
    const Y = /[ÝŸ]/g;
    const y = /[ýÿ]/g;
    const N = /Ñ/g;
    const n = /[ñ]/g;
    const C = /Ç/g;
    const c = /[ç]/g;

    const special = /[^a-zA-Z0-9 \-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]/gi;

    if (typeof value == 'string') {
        return value
            .replace(A, 'A')
            .replace(a, 'a')
            .replace(E, 'E')
            .replace(e, 'e')
            .replace(I, 'I')
            .replace(i, 'i')
            .replace(O, 'O')
            .replace(o, 'o')
            .replace(U, 'U')
            .replace(u, 'u')
            .replace(Y, 'Y')
            .replace(y, 'y')
            .replace(C, 'C')
            .replace(c, 'c')
            .replace(special, ' ')
            .trim();
    } else {
        for (const key in value) {
            if (value.hasOwnProperty(key) && exs.indexOf(key) == -1) {
                const el = value[key];
                if (typeof el == 'string') {
                    value[key] = el
                        .trim()
                        .replace(A, 'A')
                        .replace(a, 'a')
                        .replace(E, 'E')
                        .replace(e, 'e')
                        .replace(I, 'I')
                        .replace(i, 'i')
                        .replace(O, 'O')
                        .replace(o, 'o')
                        .replace(U, 'U')
                        .replace(u, 'u')
                        .replace(Y, 'Y')
                        .replace(y, 'y')
                        .replace(N, 'N')
                        .replace(n, 'n')
                        .replace(C, 'C')
                        .replace(c, 'c')
                        .replace(special, ' ')
                        .trim();
                }
            }
        }
    }
    return value;
};

const mapToSaveJasper = (value, ...exs) => {
    // Include latin characters and underline
    const special = /[^a-zA-Z0-9 \u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\-\?\!\.\_\[\]\n]/gi;

    for (const key in value) {
        if (key != 'namejasper' && key != 'pathjasper') {
            if (
                value.hasOwnProperty(key) &&
                exs.indexOf(key) == -1 &&
                key != 'datahorainc' &&
                key != 'datahoraalt' &&
                key != 'datahoradel'
            ) {
                const el = value[key];
                if (typeof el == 'string') {
                    value[key] = el.trim().replace(special, ' ').trim();
                }
            }
        }
    }

    return value;
};

const mapToupload = (value, ...exs) => {
    const special = /[^a-zA-Z0-9 \-\?\!\.\@]/gi;

    for (const key in value) {
        if (
            value.hasOwnProperty(key) &&
            exs.indexOf(key) == -1 &&
            key != 'datahorainc' &&
            key != 'datahoraalt' &&
            key != 'datahoradel'
        ) {
            const el = value[key];
            if (typeof el == 'string') {
                value[key] = el.replace(special, '_').trim();
            }
        }
    }
    return value;
};

const mapLogin = (value) => {
    const A = /[ÂÃÀÁÄ]/g;
    const E = /[ÊÈÉË]/g;
    const I = /[ÎÌÍÏ]/g;
    const O = /[ÔÕÒÓÖ]/g;
    const U = /[ÛÙÚÜ]/g;
    const Y = /[ÝŸ]/g;
    const N = /Ñ/g;
    const C = /Ç/g;
    const special = /[^a-zA-Z0-9 \-\?\!\.]/gi;

    if (value.hasOwnProperty('login')) {
        const el = value.login;
        if (typeof el == 'string') {
            value.login = el
                .toUpperCase()
                .replace(A, 'A')
                .replace(E, 'E')
                .replace(I, 'I')
                .replace(O, 'O')
                .replace(U, 'U')
                .replace(Y, 'Y')
                .replace(N, 'N')
                .replace(C, 'C')
                .replace(special, '')
                .replace(/ /g, '')
                .toLowerCase();
        }
    }

    return value;
};

const lightenDarkenColor = function (hexcolor, percent) {
    // cor formato hex
    // percent entre -100 e 100; negativo escurece, positivo clareia

    let color = hexcolor.replace('#', '');

    let num = parseInt(color, 16),
        amt = Math.round(2.55 * percent),
        R = (num >> 16) + amt,
        B = ((num >> 8) & 0x00ff) + amt,
        G = (num & 0x0000ff) + amt;

    return (
        0x1000000 +
        (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
        (B < 255 ? (B < 1 ? 0 : B) : 255) * 0x100 +
        (G < 255 ? (G < 1 ? 0 : G) : 255)
    )
        .toString(16)
        .slice(1);
};

const isColorLight = function (color) {
    // Variables for red, green, blue values
    let r, g, b, hsp;

    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        // If HEX --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

        r = color[1];
        g = color[2];
        b = color[3];
    } else {
        // If RGB --> Convert it to HEX: http://gist.github.com/983661
        color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));

        r = color >> 16;
        g = (color >> 8) & 255;
        b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // Using the HSP value, determine whether the color is light or dark
    return hsp > 127.5;
};

const getMapClusterSvg = function () {
    let color = store.state.partnerSystemHasLayout.primary_color;
    let svg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-100 -100 200 200"><g fill="${color}" opacity="0.5"><circle r="100"/></g><g fill="${color}"><circle r="80"/></g></svg>`;

    return `data:image/svg+xml;base64,${window.btoa(svg)}`;
};

const maskPhone = function (t) {
    //(99) 9999-9999
    if (t.length == 10) {
        return `(${t.substring(0, 2)}) ${t.substring(2, 6)}-${t.substring(6, 10)}`;
        //(99) 99999-9999
    } else if (t.length == 11) {
        return `(${t.substring(0, 2)}) ${t.substring(2, 7)}-${t.substring(7, 11)}`;
    } else {
        return t;
    }
};

const parseDateString = function (d) {
    if (d) {
        let a = d.split('T')[0].split('-');
        return new Date(a[0], a[1] - 1, a[2]).toLocaleDateString();
    } else {
        return '';
    }
};

const parseDateTimeString = function (d) {
    return d ? new Date(d).toLocaleString() : '';
};

const getLocale = function (old) {
    let locale = 'pt-BR';
    if (window.clang == 'en') locale = 'en-US';
    if (window.clang == 'es') locale = 'es-ES';
    return locale;
};

// Pra retornar se o gráfico deve voltar os valores do tooltip monetários ou não
const isCurrencyChart = (title) => {
    return title == 'chart-cliente-por-faturamento-abc';
};

// Retornar o VALORDECIMAPLACES da tabela EMPRESA, que está no objeto window.empresa
const getValorDP = (idempresa) => {
    let empresa = idempresa
        ? store.state.user.empresas.find((e) => e.idempresa == idempresa)
        : undefined;

    if (empresa) {
        return empresa.valordecimalplaces;
    } else if (store.state.user.empresas && store.state.user.empresas[0]) {
        return store.state.user.empresas[0].valordecimalplaces;
    } else {
        return 2;
    }
};

// Retornar o QTDEDECIMAPLACES da tabela EMPRESA, que está no objeto window.empresa
const getQtdeDP = (idempresa) => {
    let empresa = idempresa
        ? store.state.user.empresas.find((e) => e.idempresa == idempresa)
        : undefined;

    if (empresa) {
        return empresa.qtdedecimalplaces;
    } else if (store.state.user.empresas && store.state.user.empresas[0]) {
        return store.state.user.empresas[0].qtdedecimalplaces;
    } else {
        return 2;
    }
};

// Retornar o SIMBOLOMONETARIO da tabela EMPRESA, que está no objeto window.empresa
const getSimbolo = (idempresa) => {
    let empresa = idempresa
        ? store.state.user.empresas.find((e) => e.idempresa == idempresa)
        : undefined;

    if (empresa) {
        return empresa.simbolomonetario;
    } else if (store.state.user.empresas && store.state.user.empresas[0]) {
        return store.state.user.empresas[0].simbolomonetario;
    } else {
        return 'R$';
    }
};
const getDecimal = (
    numRaw,
    decimalPlaces = null,
    showMonetary = false,
    minFracDig = null,
    arredondamento = true
) => {
    /**
     * numRaw: Número a ser tratado na função;
     * decimalPlaces: Caso queira um número de casas decimais personalizado;
     * showMonetary: Caso 'true' mostra o simbolo monetário e pega o valor de casas decimais de dinheiro da config do cliente;
     * showMonetary: Caso 'false' não mostra o simbolo monetário e pega o valor de casas decimais de quantidade da config do cliente;
     * minFracDig: Não vai forças o número ter a quantidade de casas decimais mas não vai passar da quantidade estipulada.
     *
     * Modo de uso:
     * Pode ser utilizado pelo import do Util.js ou por filter.
     * As funções são globais
     * Por filter:
     *      Dentro do html: {{ valor | decimal }}
     *      ou passando parâmetros {{ valor | decimal(2, true) }}
     *      com parâmetros, o variavel antes do pipe será o primeiro parâmetro,
     *      no caso a variavel valor é o numRaw e o 2 após o decimal é o parâmetro decimalPlaces.
     */
    if (isNull(numRaw) || isNaN(+numRaw)) {
        // caso esteja nullo ou não seja numérico
        return '—';
    }
    if (decimalPlaces == null) {
        // Pega as casas decimais por dinheiro ou quantidade
        decimalPlaces = showMonetary ? getValorDP(0) : getQtdeDP(0);
    }
    // caso não tenha casas decimais pega o padrão de duas, não deixa ser menor que 0 e nem maior que 8
    decimalPlaces =
        typeof decimalPlaces != 'number'
            ? 2
            : decimalPlaces > 8
            ? 8
            : decimalPlaces < 0
            ? 0
            : decimalPlaces;
    // Pega o idioma para mostrar a formatação 'ponto e vírgila' conforme a linguagem
    let locale = 'pt-BR';
    if (window.clang == 'en') locale = 'en-US';
    if (window.clang == 'es') locale = 'es-ES';
    let num = 0;
    if (arredondamento) {
        num = +numRaw;
    } else {
        // pega o número e corta o valor exedente, ex: 3,145 com duas casas decimais vai retornar 3,14
        let re = new RegExp('^-?\\d+(?:.\\d{0,' + (decimalPlaces || -1) + '})?');
        num = +numRaw.toString().match(re)[0];
    }
    // Função de formarmatação
    num = num.toLocaleString(locale, {
        minimumFractionDigits: minFracDig != null ? minFracDig : decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    });
    // retirna o valor com ou sem simbolo monetário
    return showMonetary ? getSimbolo(0) + ' ' + num : num;
};

const isHttpUrlValid = (url) => {
    let urlObj;

    try {
        urlObj = new URL(url);
    } catch (e) {
        return false;
    }

    return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
};
const onlyNumbers = (num) => {
    //alterado para aceitar número negativos, positivos, decimais com ponto e vírgula
    let numbers = /^-?\d*\.|\,?\d+$/;
    //alterado para melhor desempenho
    return numbers.test(num);
};

/* @returns o link da rota
 * esse metodo serve para passar o name da rota
 * assim ele retorna o path que foi configurado */
const getHrefRoute = (router, name) => {
    return router.resolve({
        name: name,
    }).href;
};
/**
 * @84473 - adicionado o parâmetro verificarNegativo para ser verificado
 * a porcentagem tanto pra positivo ou negativo.
 */
const validatePorcentagem = (value, verificarNegativo = false) => {
    return !verificarNegativo ? +value >= 0 && +value <= 100 : +value >= -100 && +value <= 100;
};

const validateLatitude = (lat) => {
    let regex = /[a-zA-Z]/g;
    let invalid = regex.test(lat);
    return invalid ? !invalid : lat >= -90 && lat <= 90 && lat != 0.0;
};
const validateLongitude = (lng) => {
    let regex = /[a-zA-Z]/g;
    let invalid = regex.test(lng);
    return invalid ? !invalid : lng >= -180 && lng <= 180 && lng != 0.0;
};
const validateURL = (url) => {
    let expression =
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gi;
    let regex = new RegExp(expression);
    return regex.test(String(url));
};
/**
 *
 * @param {*} url url digitada no input
 * @returns retorna se o domínio inserido é válido
 *
 * @70731
 */
const validateDominioURL = (url) => {
    for (let sufixo of '.org .gov .mil .edu .ind .net .com .br .com.br'.split(' ')) {
        if (url.includes(sufixo)) {
            return true;
        }
    }
    return false;
};
const validateFTP = (url) => {
    let expression = /^(?:ftp?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gi;
    let regex = new RegExp(expression);
    return regex.test(String(url));
};
const isNull = (val) => {
    // Verifica se o valor da variável está contido em um dos elementos do array tests
    let tests = [null, '', ' ', undefined, 'null', 'undefined'];
    return tests.includes(val);
};
// Transforma um inteiro em uma string de porcentagem
const parseAsPercent = (num) => {
    return new Intl.NumberFormat('default', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(num / 100);
};

const cutString = (str, cutIn = 50) => {
    if (isNull(str)) return '---';
    return str.length > cutIn ? str.substring(0, cutIn) + '...' : str;
};
// para arrays de números inteiros convertidos em string
const justNumbersAndComma = (value) => {
    let type = typeof value;
    if (type == 'string' || type == 'number') {
        let expression = /[^0-9 ,\n]/gi;
        return value.toString().replace(expression, '').trim();
    } else {
        console.log('[justNumbersAndComma] Dado passado não é uma string.');
        return value;
    }
};

// classe para ser usada no throw
// Ex: throw new this.ErrorMsg('without-data');
class ErrorMsg {
    constructor(msg) {
        this.response = {
            data: {
                message: msg,
                type: 'ErrorMsg',
            },
        };
    }
}

const tagnew = (v, posicao = 'r') => {
    /*
    posição = l: left, r:right
    posição do absolute = t: top, b: bottom
    Ex: :class="tagnew('140621', 'rt')"
    */
    let versoes = process.env.VUE_APP_NEW_VERSION.split(',');
    return versoes.filter((f) => f == v).length > 0 ? 'tagnew-' + posicao : null;
};
/**
 * Valida as permissões de acesso do usuário:
 * Retorna as permissões de READ, CREATE, UPDATE, DELETE e EXPORT do usuário para aquela tela específica.
 */
const hasPermissionAccess = (modulo, submodulo, codTela) => {
    let per = {
        read: false,
        create: false,
        update: false,
        delete: false,
        export: false,
    };

    if (
        store.state.app_modulo.disponivel &&
        store.state.app_modulo.data &&
        !store.state.app_modulo.data.admin
    ) {
        store.state.app_modulo.data.app_moduloList.forEach((app_modulo) => {
            if (app_modulo.nome == modulo) {
                app_modulo.app_moduloList.forEach((app_modulo2) => {
                    if (app_modulo2.nome == submodulo) {
                        app_modulo2.app_telaList.forEach((app_tela) => {
                            if (app_tela.codigounicotela == codTela) {
                                per.read = app_tela.perm_perfilacessotelas
                                    ? app_tela.perm_perfilacessotelas.read
                                    : false;
                                per.create = app_tela.perm_perfilacessotelas
                                    ? app_tela.perm_perfilacessotelas.create
                                    : false;
                                per.update = app_tela.perm_perfilacessotelas
                                    ? app_tela.perm_perfilacessotelas.update
                                    : false;
                                per.delete = app_tela.perm_perfilacessotelas
                                    ? app_tela.perm_perfilacessotelas.delete
                                    : false;
                                per.export = app_tela.perm_perfilacessotelas
                                    ? app_tela.perm_perfilacessotelas.export
                                    : false;
                            }
                        });
                    }
                });
            }
        });
    } else if (store.state.app_modulo.data && store.state.app_modulo.data.admin) {
        per.read = true;
        per.create = true;
        per.update = true;
        per.delete = true;
        per.export = true;
    }

    return per;
};

// formatar CPF e CNPJ
const formatCpfCnpj = (cpfCnpj) => {
    if (typeof cpfCnpj == 'string') {
        let n = cpfCnpj.replace(/[\.\-]/g, '');

        if (n.length == 11) {
            // xxx.xxx.xxx-xx
            return `${n.substr(0, 3)}.${n.substr(3, 3)}.${n.substr(6, 3)}-${n.substr(9, 2)}`;
        } else if (n.length == 14) {
            // xx.xxx.xxx/xxxx-xx
            return `${n.substr(0, 2)}.${n.substr(2, 3)}.${n.substr(5, 3)}/${n.substr(
                8,
                4
            )}-${n.substr(12, 2)}`;
        } else {
            return cpfCnpj;
        }
    } else {
        return cpfCnpj;
    }
};

// eliminar e usar regra venda do cadastro de cliente - Pedir para Yan fazer alteração
const parseAsCurrency = (num) => {
    return new Intl.NumberFormat('default', {
        style: 'currency',
        currency: 'BRL',
    }).format(num);
};

// caso não tenha tradução retorna o valor de msg, caso contrário retorna a tradução
function getT(toTranslate = null, msg = 'empty') {
    if (isNull(toTranslate)) {
        return i18n.te(msg) ? i18n.t(msg) : msg;
    } else {
        return i18n.te(toTranslate) ? i18n.t(toTranslate) : toTranslate;
    }
}
// Alias: getTranslation returns getT
const getTranslation = getT;

/*
    @89999 - O objeto translatedItem e responsavel por prover tanto a chave do
    dicionario quanto o valor atrelado. A key sera 'nomeTabela-nomeAtributo'
    e o valor sera o retornado na requisicao
*/
function translateItemKeys(content, table) {
    const translatedItem = {};
    if (content) {
        Object.keys(content).forEach(key => {
            translatedItem[table + key] = formatValues(key, content[key]);
        });
    }
    return translatedItem;
}

function formatValues(key, value) {
    const isNull = value === null || value === 'null' || value === 'NULL'
    if (isNull) {
        value = '---';
    } else if (!key.includes('id') && typeof value === 'number') {
        if (key.includes('desconto') || key.includes('percentual')) {
            value = parseAsPercent(value);
        } else {
            value = getDecimal(value);
        }
    } else if (key.includes('tipoAutorizacao')) {
        value = i18n.t(value)
    }
    return value;
}

// To convert an array to a string and then back to an object
const arrayToStringAndBack = (array) => {
    // Convert array to JSON string
    const jsonString = JSON.stringify(array);
    // Convert JSON string back to object
    return JSON.parse(jsonString);
};

// sort an array of objects by a specific element value
const sortArrayByObjectKey = (array, key) => {
    if (Array.isArray(array)) {
        // Sort the array based on the specified key
        return array.sort((a, b) => {
            if (a[key] < b[key]) return -1;
            if (a[key] > b[key]) return 1;
            return 0;
        });
    } else {
        return [];
    }
}

const getTelaDefaultByContext = (context = null) => {
    if (context == 'vendas') {
        return 'ven-cockpit';
    } else if (context == 'promotor') {
        return 'pro-cockpit';
    } else if (context == 'despesas') {
        return 'des-cockpit';
    } else if (context == 'agro') {
        return 'agro-cockpit';
    } else if (context == 'b2b') {
        return 'b2b-parametrizacoes';
    } else if (context == 'prestacao-servico') {
        return 'serv-cockpit';
    } else if (context == 'jupiter') {
        return 'usuario-controle-aparelhos-jupiter';
    }
    return null;
};

const isPrefixSovisInIdErpInvalid = (idErp, originalIdErp) => {
    const idErpHasSovisPrefix = idErp.includes('GA-');
    const idErpHasChanged = idErp != originalIdErp;

    return idErpHasSovisPrefix && idErpHasChanged;
}

export {
    ErrorMsg,
    debounce,
    orderByLabelCombo,
    validateEmail,
    validateWhatsapp,
    validateCPF,
    validateCnpj,
    downloadPpt,
    isValidDate,
    validateHour,
    validatePhone,
    validateCellPhone,
    changeDDIPattern,
    formatPhoneNumber,
    formatCEP,
    formatCNPJ,
    formatCPF,
    hexToRgb,
    rgbToHsl,
    validateCEP,
    validateIE,
    validateRG,
    removeAcentos,
    removeToSearch,
    mapTosave,
    mapToSavePreserveCase,
    mapToSaveURL,
    mapToSaveJasper,
    mapToupload,
    mapLogin,
    lightenDarkenColor,
    isColorLight,
    getMapClusterSvg,
    maskPhone,
    parseDateString,
    parseDateTimeString,
    getLocale,
    isCurrencyChart,
    getValorDP,
    getQtdeDP,
    getSimbolo,
    getDecimal,
    isHttpUrlValid,
    onlyNumbers,
    getHrefRoute,
    validatePorcentagem,
    validateLatitude,
    validateLongitude,
    validateURL,
    validateDominioURL,
    validateFTP,
    isNull,
    parseAsPercent,
    cutString,
    justNumbersAndComma,
    tagnew,
    hasPermissionAccess,
    formatCpfCnpj,
    getTranslation,
    getT,
    parseAsCurrency,
    getModulo,
    hasModulo,
    translateItemKeys,
    formatValues,
    arrayToStringAndBack,
    sortArrayByObjectKey,
    getTelaDefaultByContext,
    isPrefixSovisInIdErpInvalid,
};
